import { AgentMessage, AgentToolResultPart, getEventText, isOpeningMessage } from "./protocol";

export interface OptionPick {
  position: number; // counts from 1, and 1 is the option the chat recommends
  count: number;
}

export type MessageOrigin = { source: "typed" } | { source: "starter" } | ({ source: "option" } & OptionPick);

// Only starters are kept as text: they are fixed prompts, while typed text and the chat's options can name people or clients.
export const messageSentProperties = ({ text, origin, hasAttachment }: { text: string; origin: MessageOrigin; hasAttachment: boolean }) => {
  if (origin.source === "typed") return { source: origin.source, hasAttachment, length: text.length };
  if (origin.source === "starter") return { source: origin.source, hasAttachment, starter: text };
  return { source: origin.source, hasAttachment, position: origin.position, count: origin.count };
};

// No error text: a tool's error can repeat what the user gave, such as a URL to read.
export const toolResultProperties = ({ tool, result, durationMs }: { tool: string; result: AgentToolResultPart; durationMs: number }) => ({
  tool,
  ok: !result.isError,
  durationMs
});

const isUserMessage = (message: AgentMessage): boolean =>
  message.role === "user" && !isOpeningMessage(message.content) && getEventText(message.content) === null;

export const postSavedProperties = ({
  history,
  agentTouch,
  isDraft,
  isPostedNow
}: {
  history: AgentMessage[];
  agentTouch: Record<string, number | null>; // when the chat last changed each part of the post
  isDraft: boolean;
  isPostedNow: boolean;
}) => ({
  messagesSent: history.filter(isUserMessage).length,
  chatChanges: Object.keys(agentTouch).filter(area => agentTouch[area] !== null),
  isDraft,
  isPostedNow
});
